import template from './visual-divider.jade';

export default angular
    .module('cian.addForm.aboutObjectDivider', ['cian.addForm.visualDivider'])
    .directive('cianAfAboutObjectVisualDivider', () => ({
        template,
    }))
    .name;
